import React, { useState } from "react";
import CopyImg from "./copy-solid.svg";

export default function Textform(props) {
  const [text, setText] = useState("");

  // setText("heavy");
  const hadleUpClick = () => {
    console.log("Upper Case was Clicked");
    setText(text.toUpperCase());

    props.showAlert("Converted to UpperCase", "success");
  };
  const hadleLoClick = () => {
    console.log("Lower Case was Clicked");
    setText(text.toLowerCase());
    props.showAlert("Converted to LowerCase", "success");
  };
  const deleteKrde = () => {
    console.log("Delete was Clicked");
    setText(" ");
    props.showAlert("Text Cleared", "success");
  };
  const spaceRemover = () => {
    setText(text.replace(/\s+/g, " "));
  };
  const handleOnChange = (event) => {
    console.log("OnChange hit");
    setText(event.target.value);
  };
  const copyText = () => {
    console.log("copytext clicked");
    var textcopy = text;
    console.log(textcopy);
    if (text !== "") {
      navigator.clipboard.writeText(textcopy);
      props.showAlert("Copied to Clipboard!", "success");
      console.log("saved");
    } else {
      props.showAlert("Nothing was wrote in the text section", "warning");
    }
  };

  return (
    <div className="my-1">
      <div className="container my-5">
        <div className="texthai" style={{ float: "right" }}>
          <div
            className="cpybtn mx-2"
            style={{ position: "relative", float: "right", top: "3.5vh" }}
          >
            <img src={CopyImg} onClick={copyText} style={{ width: "13px" }} />
          </div>
          <p
            id="textLength"
            className="mx-1"
            style={{ color: props.mode === "dark" ? "white" : "black" }}
          >
            <b>
              {" "}
              {(
                text.split(/\s+/).filter((element) => {
                  return element.length !== 0;
                }).length * 0.008
              ).toFixed(1)}
            </b>
            : Minutes read
          </p>
          <p
            id="textLength"
            className="mx-1"
            style={{ color: props.mode === "dark" ? "white" : "black" }}
          >
            <b>
              {" "}
              {Math.round(
                text.split(/\s+/).filter((element) => {
                  return element.length !== 0;
                }).length
              )}
            </b>
            : Words
          </p>
        </div>

        <div className="buttonin mb-3">
          <textarea
            className="form-control "
            id="Textarea"
            value={text}
            style={{
              color: props.mode === "dark" ? "white" : "black",
              backgroundColor: props.mode === "dark" ? "#40445c" : "white",
            }}
            onChange={handleOnChange}
            rows="10"
            placeholder="Enter text here "
          ></textarea>
          {/* <img className='imgCopy' src={logo} alt="myImg"/> */}
        </div>
        <div className="buttonshain mb-5">
          <div className="button">
            <button
              disabled={text.length === 0}
              className="btn  mx-1 my-1"
              onClick={hadleUpClick}
              style={{
                color: props.mode === "dark" ? "black" : "white",
                backgroundColor: props.mode === "dark" ? "white" : "#030e12",
              }}
            >
              Uppercase
            </button>
            <button
              disabled={text.length === 0}
              className="btn  mx-1 my-1"
              onClick={hadleLoClick}
              style={{
                color: props.mode === "dark" ? "black" : "white",
                backgroundColor: props.mode === "dark" ? "white" : "#030e12",
              }}
            >
              LowerCase
            </button>
            <button
              disabled={text.length === 0}
              className="btn mx-1 my-1"
              onClick={spaceRemover}
              style={{
                color: props.mode === "dark" ? "black" : "white",
                backgroundColor: props.mode === "dark" ? "white" : "#030e12",
              }}
            >
              Space Remover
            </button>
          </div>
          <div className="clearbutton">
            <button
              disabled={text.length === 0}
              className="btn mx-1 my-0.5"
              id="clearBtn"
              onClick={deleteKrde}
              style={{
                color: props.mode === "dark" ? "black" : "white",
                backgroundColor:
                  props.mode === "dark" ? "red" : "#030e12 !important",
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
